import { StateUtils } from '@spartacus/core';
import { Reaming } from '../../../../../core/model';
import { CartEntryReamingActionTypes } from '../actions/cart-entry-reaming.action';
import { CartActions } from '../actions/index';

export const initialState: Reaming = undefined;

export function reducer(state = initialState, action: CartActions.CartEntryReamingActions | StateUtils.LoaderAction): Reaming {
  switch (action.type) {
    case CartEntryReamingActionTypes.AddCartEntryReamingSuccess: {
      return {
        ...state,
        reamed: true,
      };
    }
    case CartEntryReamingActionTypes.RemoveCartEntryReamingSuccess: {
      return initialState;
    }
  }
  return state;
}
